import React, { useEffect } from "react";

export interface ApiError {
  type: ApiErrorType;
  message?: string;
}

enum ApiErrorType {
  genericError = "generic-error",
  internetError = "internet-error",
  stringError = "string-error",
}

const ApiErrorFor = (error: any): ApiError => {
  if (
    error &&
    typeof error === "object" &&
    "type" in error &&
    "message" in error
  ) {
    return error as ApiError;
  }

  if (typeof error === "string") {
    return {
      type: ApiErrorType.stringError,
      message: error,
    };
  }

  const apiError: ApiError = {
    type: ApiErrorType.genericError,
    message: "Something went wrong!",
  };

  if (error.response && error.response.status) {
    return apiError;
  }

  apiError.type = ApiErrorType.internetError;
  apiError.message = "No internet connection detected.";

  return apiError;
};

const ErrorPrompt = ({
  error,
  onClose,
}: {
  error?: any;
  onClose: () => void;
}) => {
  const apiError: any = error ? ApiErrorFor(error) : "";

  useEffect(() => {
    const timer = setTimeout(onClose, 2500);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="flex flex-col items-center">
      <div className="fixed top-5 w-[95%] sm:w-1/2 lg:w-1/3 xl:w-1/4 bg-primary text-font-on-primary py-3 px-4 flex justify-between items-center z-[100] rounded-xl select-none">
        <span className="basis-3/4">{apiError.message}</span>
        <button onClick={onClose}>
          <img
            src="/icons/close.svg"
            alt="close"
            className="h-3 w-3 cursor-pointer"
          />
        </button>
      </div>
    </div>
  );
};

export default ErrorPrompt;
